import $ from 'jquery';

// https://developer.mozilla.org/docs/Web/API/ParentNode/append
if (!Element.prototype.append) {
  Element.prototype.append = function (...nodes) {
    $(this).append(nodes);
  };
}

// https://developer.mozilla.org/docs/Web/API/ParentNode/prepend
if (!Element.prototype.prepend) {
  Element.prototype.prepend = function (...nodes) {
    $(this).prepend(nodes);
  };
}

// https://developer.mozilla.org/docs/Web/API/Element/closest
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    return $(this).closest(s)[0];
  };
}

// https://developer.mozilla.org/docs/Web/API/Element/matches
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

// https://developer.mozilla.org/docs/Web/API/ChildNode/remove
if (!Element.prototype.remove) {
  Element.prototype.remove = function () {
    this.parentNode && this.parentNode.removeChild(this);
  };
}
